import type {ReactNode} from 'react';
import {cn} from '../lib/cn';

export type ErrorMessageProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
};

export function ErrorMessage({className, children, disabled}: ErrorMessageProps) {
  return (
    <div
      className={cn(
        'mt-0.5 text-left text-sm font-medium text-[var(--error-message-color)]',
        disabled && 'opacity-30',
        className,
      )}
    >
      {children}
    </div>
  );
}
